<template>
  <div>
    <NoteBox header="Help families get to know you">
      <ul class="text-body-2 list-disc mt-8 ml-16">
        <li>{{ careTypeTip }}</li>
        <li>What experience do you have?</li>
        <li>What skills and training do you have?</li>
      </ul>
      <button
        v-if="isChildCare"
        class="text-overline text-grey-clickable link-secondary underline mt-16"
        @click.prevent="openExamplesPopup"
      >
        View example bios
      </button>
    </NoteBox>
    <Popup v-model="showPopup" popupHeader="Examples" :hasHeaderDivider="true" popupSize="lg">
      <ul>
        <li
          v-for="(example, index) in bioExamples"
          :key="index"
          class="text-body border-b-1 border-solid border-grey-divider-subdued py-24 last:border-b-0 select-none"
        >
          {{ example.bio }}
        </li>
      </ul>
    </Popup>
  </div>
</template>

<script lang="ts">
import NoteBox from '@/components/note_box/NoteBox.vue';
import Popup from '@/components/popup/Popup.vue';
import { bioExamples } from './__examples__/BioExamples';
import { sendSegmentEvent } from '@/lib/segment';

export default {
  name: 'BioAreaNoteBox',
  components: { NoteBox, Popup },
  props: {
    careType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      bioExamples,
      showPopup: false,
    };
  },
  computed: {
    isChildCare(): boolean {
      return this.careType === 'babysitter' || this.careType === 'nanny';
    },
    careTypeTip(): string {
      const careTypeEndings: { [key: string]: string } = {
        housekeeping: 'being a housekeeper?',
        companionCare: 'being a caregiver?',
        petCare: 'working with pets?',
      };

      return `Why do you love ${careTypeEndings[this.careType] || 'being a sitter?'}`;
    },
  },
  methods: {
    openExamplesPopup() {
      this.showPopup = true;
      sendSegmentEvent('Profile - Viewed Example Bios', {});
    },
  },
};
</script>
